import { $, freeze, handleESC } from '../utils/Utils';

const mobileNav = (() => {
  const config = {
    checkbox: $('#menu-trigger')[0],
    mobileNav: $('.nav__mobile')[0],
  };

  const hideNav = () => {
    config.checkbox.checked = false;
    document.body.classList.remove(config.bodyCN);
    freeze.stop();
    handleESC.stop();
  };

  const showNav = () => {
    document.body.classList.add(config.bodyCN);
    handleESC.init(() => hideNav());
    freeze.start();
  };

  const handleClick = ({ e }) => {
    if (
      document.body.classList.contains(config.bodyCN) &&
      !config.mobileNav.contains(e.target)
    ) {
      hideNav();
    }
  };

  const handleChange = () => {
    if (config.checkbox.checked) {
      showNav();
    } else {
      hideNav();
    }
  };

  const init = () => {
    // Close mobile nav if click on outside area
    document.addEventListener('click', e => handleClick({ e }));

    // Add body class if nav is open
    config.checkbox.addEventListener('change', () => handleChange());
    config.checkbox.dispatchEvent(new Event('change'));
  };

  return {
    init,
  };
})();

mobileNav.init();
